<template>
  <div class="details-wrapper">
    <div class="details-body">
      <tol-sidebar :menu-items="sidebarMenu" />
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <section class="details-section">
            <h1>{{ this.$t('client.labels.details') }}</h1>
            <ClientDetailsForm :client-details="getNewClient" @formDataChange="dataModified" />
          </section>
          <section class="details-section">
            <h1>{{ this.$t('client.labels.addresses') }}</h1>
            <div class="add">
              <span @click="addClientAddress">+</span>
            </div>
            <div class="address-section">
              <div v-for="(address, index) in getNewClientAddressList" :key="index" class="address">
                <tol-address
                  :address="address"
                  :default-id="getNewClient.address_id"
                  :editable="true"
                  @change="updateAddress"
                />
              </div>
            </div>
            <div class="action-block">
              <tol-button
                id="save-btn"
                :button-type="'minor'"
                icon-name="save"
                :class="['client-action', { disabled: !isOnScreenDataModified }]"
                tooltip="SAVE"
                @click="saveClientDetails()"
              >
              </tol-button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AppActions } from '@/app/app.keys';
import { NewClientGetters, NewClientActions } from './new-client.keys';
import TolSidebar from '@/app/components/TolSidebar';
import TolAddress from '@/app/components/TolAddress';
import TolButton from '@/app/components/TolButton';
import ClientDetailsForm from '@/app/features/clients/features/client-details/components/ClientDetailsForm';
export default {
  components: {
    TolSidebar,
    TolButton,
    TolAddress,
    ClientDetailsForm
  },
  data() {
    return {
      client: {},
      isOnScreenDataModified: false,
      isProcessBtnClicked: false,
      sidebarMenu: [
        { label: this.$t('client.labels.details') },
        { label: this.$t('client.labels.addresses') },
        { label: this.$t('client.labels.attachments') },
        { label: this.$t('client.labels.billingMethods') }
      ]
    };
  },
  computed: {
    getNewClient() {
      return this.$store.getters[NewClientGetters.GetNewClient];
    },
    getNewClientAddressList() {
      return this.$store.getters[NewClientGetters.GetNewClientAddressList];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, 'New Client');
  },
  destroyed() {
    this.$store.dispatch(NewClientActions.ResetNewClientDetails);
  },
  methods: {
    dataModified(formData) {
      this.isOnScreenDataModified = true;
      this.$store.dispatch(NewClientActions.UpdateNewClientDetails, formData);
    },
    addClientAddress() {
      this.isOnScreenDataModified = true;
      let address = {
        id: (Math.random() * (0.1 - 0.99)).toFixed(4),
        line1: null,
        line2: null,
        city: null,
        postal_code: null,
        province_abbr: null
      };
      this.$store.dispatch(NewClientActions.AddNewClientAddress, address);
    },
    saveClientDetails() {
      this.isProcessBtnClicked = true;
      this.$store.dispatch(NewClientActions.SaveNewClientDetails);
      window.setTimeout(() => {
        this.isProcessBtnClicked = false;
        this.isOnScreenDataModified = false;
      }, 2000);
    },
    updateAddress(address) {
      this.isOnScreenDataModified = true;
      if (address.name === 'is_default') {
        this.$store.dispatch(NewClientActions.UpdateNewClientDefaultAddress, address.value);
      } else {
        this.$store.dispatch(NewClientActions.UpdateNewClientAddress, address);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;
  .details-header {
    display: flex;

    padding: $details-padding;
    border-bottom: 2px solid $row-border;
    justify-content: space-between;
  }
  .details-body {
    position: relative;
    display: flex;
    justify-content: space-between;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      flex: 0 85%;
      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px;
      }
    }

    .details-section {
      padding-bottom: 25px;

      h1 {
        border-bottom: 1px solid $row-border;
      }
    }

    .address-section {
      display: flex;
      flex-wrap: wrap;
      .address {
        margin: 10px;
      }
    }
  }

  .add {
    display: flex;
    justify-content: flex-end;
    span {
      display: inline-block;
      font-size: 1.2em;
      font-weight: bold;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 100%;
      text-align: center;
      &:hover {
        cursor: pointer;
        background-color: $light-grey-2;
      }
      &.history {
        display: none;
      }
    }
  }
  .client-action {
    width: 50px;
    height: 50px;
    padding: 0;
    font-size: 1.5em;
    margin-right: 20px;
    color: $white;
    border-radius: 100%;
    background-color: $secondary-green;

    &.disabled {
      background-color: $light-grey-2;
      color: $light-grey-1;
      &:hover {
        background-color: $light-grey-2;
        color: $light-grey-1;
        cursor: not-allowed;
      }
    }
  }
}
</style>
